import React, { Component } from "react";
import Employes from "../../../components/employes/Employes";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : EmployesForm
Description : Compoente que alberga el resto del formulario de Employes definido en el directorio de componentes
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente de Employes
================================================================================ */

class EmployesForm extends Component{
    render(){
        return(
            <Employes/>  
        )   
    }
}

export default EmployesForm;